import { cn as e } from "../../../lib/utils.es.js";
import { checkboxVariants as n } from "./Checkbox.variants.es.js";
import { jsx as o } from "react/jsx-runtime";
import { CheckIcon as a } from "lucide-react";
import * as i from "@radix-ui/react-checkbox";
function h({ className: t, size: r, ...c }) {
  return /* @__PURE__ */ o(i.Root, {
    className: e(n({ size: r }), t),
    "data-slot": "checkbox",
    ...c,
    children: /* @__PURE__ */ o(i.Indicator, {
      className: "lib:flex lib:items-center lib:justify-center lib:transition-none",
      "data-slot": "checkbox-indicator",
      children: /* @__PURE__ */ o(a, {})
    })
  });
}
export {
  h as UiCheckbox
};
